<template>
  <div>
    <div class="md-layout send-share">
      <div class="md-layout-item share-item">
        <div class="copy-share">
          <div
            class="share-container"
            :class="[
              {
                'has-value': copyText === 'Copied!',
              },
            ]"
          >
            <div class="share-link">
              <span> {{ inviteLink }} </span>
            </div>
            <md-button
              class="md-dense share-button"
              v-clipboard:copy="inviteLink"
              v-clipboard:success="onCopy"
              :md-ripple="false"
              @click="$emit('closeModal')"
            >
              {{ copyText }}
            </md-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserHelper from "@/mixins/UserHelper.vue";
import Global from "@/constants/Global.js";
export default {
  name: "ShareBox",
  props: ["category","userInfo"],
  mixins: [UserHelper],
  data() {
    return {
      frontUrl: Global.getFrontDomain(),
      copyText: "Copy",
      request_state: "WAITING",
      result: null,
      req_result: null,
    };
  },
  methods: {
    onCopy() {
      this.copyText = "Copied!";
    }
  },
  computed: {
    inviteLink() {

      if (this.category)
        return `${this.frontUrl}/${this.userInfo.username}/inventory/${this.category}`;
      else
        return `${this.frontUrl}/${this.userInfo.username}/inventory`;
    },
  },
  watch: {
  },
  components: {
  },
};
</script>

<style lang="scss" scoped>
.send-share {
  display: flex;
  place-content: center;
  align-items: center;
}
.share-item {
  display: flex;
  justify-content: center;
}
.copy-share {
  width: 30rem;
}
.share-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  border: 1px solid rgba(0, 0, 0, 0.62);
  box-sizing: border-box;
  border-radius: 7px;
  height: 3rem;
  margin-top: 1em;
}
.share-container:focus-within {
  border: 1px solid $primary;
}
.has-value {
  border: 1px solid $primary !important;
}
.has-value label {
  color: $primary;
}
.share-link {
  display: flex;
  margin-left: 0.8rem;
  width: 74.8%;
  overflow: hidden;
}
.share-link span {
  white-space: nowrap;
  font-size: 12px;
  color: black;
}
.share-button {
  color: $primary;
  text-transform: none;
}
.social-media-share {
  margin: 3rem 0 4rem 0;
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .send-share {
    display: flex;
    place-content: center;
    flex-direction: column;
    align-items: flex-start;
  }
  .copy-share span {
    margin-left: 0;
  }
}
@media screen and (min-width: 1024px) {
  .share-link {
    width: 80%;
    overflow: hidden;
  }
}
</style>

<style lang="scss">
.md-button::before {
  width: 0;
}
</style>

